import scss from "./BasicTable.module.scss";
import { useTranslation } from "react-i18next";
import { splitInventoryContent } from "../inventoryContent";

// Flatten the set -> groups -> attributes tree into a plain list of {id, name, valuesHtml}
// rows, ignoring group boundaries - the header-info position renders as individual grid
// items alongside Šifra/Lager, not as a grouped block.
function flattenSpecificationAttributes(specification) {
    const rows = [];
    (specification ?? []).forEach((data) => {
        Object.values(data?.groups ?? {}).forEach((item) => {
            Object.values(item?.attributes ?? {}).forEach((attribute) => {
                rows.push({
                    id: attribute?.attribute?.id,
                    name: attribute?.attribute?.name,
                    valuesHtml: (attribute?.values ?? []).map((value) => value.name).join(", "),
                });
            });
        });
    });
    return rows;
}

const BasicTable = ({ productVariant, basic, headerSpecification, translateKey }) => {
    const { t } = useTranslation();

    let inventory = basic?.data?.item?.inventory ? basic?.data?.item?.inventory : false;
    let sku = basic?.data?.item?.basic_data?.sku;
    let barcode = basic?.data?.item?.basic_data?.barcode;
    let short_description = basic?.data?.item?.basic_data?.short_description;

    if ((productVariant && !Array.isArray(productVariant)) || (Array.isArray(productVariant) && productVariant?.length > 0)) {

        inventory = productVariant?.inventory ? productVariant?.inventory : false;
        sku = productVariant?.basic_data?.sku ? productVariant?.basic_data?.sku : sku;
        barcode = productVariant?.basic_data?.barcode ? productVariant?.basic_data?.barcode : barcode;
        short_description = productVariant?.basic_data?.short_description ? productVariant?.basic_data?.short_description : short_description;
    }
    const headerSpecificationRows = flattenSpecificationAttributes(headerSpecification);
    const { details: inventoryDetails } = splitInventoryContent(inventory);

    return (
        <div className={scss.container}>
            <div className={scss.infoGrid}>
                <div className={`${scss.data}`}>
                    <span className={scss.dataTitle}>{t(`${translateKey}-code`)}:</span>
                    <span className={scss.dataValue}>{sku}</span>
                </div>

                {barcode && (
                    <div className={`${scss.data}`}>
                        <span className={scss.dataTitle}>{t(`${translateKey}-barcode`)}:</span>
                        <span className={scss.dataValue}>{barcode}</span>
                    </div>
                )}
                {inventoryDetails.map((detail, index) => (
                    <div className={scss.inventoryDetail} key={index}>{detail}</div>
                ))}

                {headerSpecificationRows.map((row) => (
                    <div className={scss.data} key={row.id}>
                        <span className={scss.dataTitle} dangerouslySetInnerHTML={{ __html: `${row.name}:` }} />
                        <span className={scss.dataValue} dangerouslySetInnerHTML={{ __html: row.valuesHtml }} />
                    </div>
                ))}
            </div>

            {short_description && <div className={scss.wrapper} dangerouslySetInnerHTML={{ __html: short_description }} />}
        </div>
    );
};

export default BasicTable;
